var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScissors = function SvgScissors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.257 2.049a3.717 3.717 0 0 1 3.016 5.885l3.217 3.216 7.888-7.887a.6.6 0 0 1 .848.847l-8.302 8.302-.01.012-.01.009-3.632 3.63a3.717 3.717 0 1 1-.848-.849l3.217-3.216-3.216-3.217c-.61.44-1.359.701-2.168.701a3.717 3.717 0 0 1 0-7.433m8.718 12.435a.6.6 0 0 1 .848 0l5.403 5.403a.6.6 0 0 1-.848.848l-5.403-5.403a.6.6 0 0 1 0-.848m-8.718 1.232a2.518 2.518 0 1 0 1.785.744l-.007-.006-.007-.008a2.5 2.5 0 0 0-1.771-.73m0-12.468a2.518 2.518 0 1 0 0 5.036 2.518 2.518 0 0 0 0-5.036"
  })));
};
export default SvgScissors;